import { ISurvey } from './common';

export const QUESTIONS_FOLLOWUP_SURVEYS_1: Array<ISurvey> = [
  {
    id: 'OverallWellBeing',
    title: 'How would you describe your overall well-being?',
    type: 'PICKONE',
    options: [
      {
        text: 'Great',
        value: 'Great',
        score: 4,
      },
      {
        text: 'Good',
        value: 'Good',
        score: 3,
      },
      {
        text: 'OK',
        value: 'OK',
        score: 2,
      },
      {
        text: 'Not so good',
        value: 'Not so good',
        score: 1,
      },
      {
        text: 'Bad',
        value: 'Bad',
        score: 0,
      },
    ],
    cantBypass: true,
    nextTitle: `Continue`,
  },
  {
    id: 'HowManyHealthApps',
    title: 'How many health apps do you currently use to manage your health?',
    type: 'PICKONE',
    options: [
      {
        text: 'none',
        value: 'none',
      },
      {
        text: '1',
        value: '1',
      },
      {
        text: '2-4',
        value: '2-4',
      },
      {
        text: '5-8',
        value: '5-8',
      },
      {
        text: '9 or more',
        value: '9 or more',
      },
    ],
    nextTitle: `Continue`,
  },
  {
    id: 'SatisfiedLastDoctorVisit',
    title: "How satisfied are you with your last Paloma video visit?",//'How satisfied are you with your last Paloma doctor visit?',
    type: 'PICKONE',
    options: [
      {
        text: 'Not satisfied at all',
        value: 'Not satisfied at all',
      },
      {
        text: 'Somewhat dissatisfied',
        value: 'Somewhat dissatisfied',
      },
      {
        text: 'A bit dissatisfied',
        value: 'A bit dissatisfied',
      },
      {
        text: 'Not satisfied, not dissatisfied',
        value: 'Not satisfied, not dissatisfied',
      },
      {
        text: 'A bit satisfied',
        value: 'A bit satisfied',
      },
      {
        text: 'Somewhat satisfied',
        value: 'Somewhat satisfied',
      },
      {
        text: 'Fully satisfied',
        value: 'Fully satisfied',
      },
    ],
    nextTitle: `Continue`,
    cantBypass: true,
  },
  {
    id: 'DetailsLastDoctorVisit',
    title: 'Anything to share with us about your last visit?',
    type: 'OPENTEXT',
    nextTitle: `Continue`,
    // cantBypass: true,
  },
  {
    id: 'HowOftenSkipMedication',
    title: 'How often do you skip taking your thyroid medication?',
    type: 'PICKONE',
    options: [
      {
        text: `Few times a week`,
        value: `Few times a week`
      },
      {
        text: 'Once a week',
        value: 'Once a week',
      },
      {
        text: 'Once every two weeks',
        value: 'Once every two weeks',
      },
      {
        text: 'Once a month',
        value: 'Once a month',
      },
      {
        text: 'Once every few months',
        value: 'Once every few months',
      },
      {
        text: 'Never or almost never',
        value: 'Never or almost never',
      },
      {
        text: 'I do not take thyroid medication',
        value: 'I do not take thyroid medication',
      },
    ],
    nextTitle: `Continue`,
    cantBypass: true,
  },
  {
    id: 'SensitiveCold',
    title: 'In the past 4 weeks have you been sensitive to cold?',
    type: 'PICKONE',
    options: [
      {
        text: 'Not at all',
        value: 'Not at all',
        score: 4,
      },
      {
        text: 'A bit',
        value: 'A bit',
        score: 3,
      },
      {
        text: 'Somewhat',
        value: 'Somewhat',
        score: 2,
      },
      {
        text: 'Quite a lot',
        value: 'Quite a lot',
        score: 1,
      },
      {
        text: 'Fully',
        value: 'Fully',
        score: 0,
      },
    ],
    nextTitle: `Continue`,
    cantBypass: true,
  },
  // {
  //   id: 'SwollenHandsFeet',
  //   title: 'In the past 4 weeks have you had swollen hands or feet?',
  //   type: 'PICKONE',
  //   options: [
  //     {
  //       text: 'Not at all',
  //       value: 'Not at all',
  //       score: 4,
  //     },
  //     {
  //       text: 'A bit',
  //       value: 'A bit',
  //       score: 3,
  //     },
  //     {
  //       text: 'Somewhat',
  //       value: 'Somewhat',
  //       score: 2,
  //     },
  //     {
  //       text: 'Quite a lot',
  //       value: 'Quite a lot',
  //       score: 1,
  //     },
  //     {
  //       text: 'Fully',
  //       value: 'Fully',
  //       score: 0,
  //     },
  //   ],
  //   nextTitle: `Continue`,
  //   cantBypass: true,
  // },
  {
    id: 'DrySkin',
    title: 'In the past 4 weeks have you had dry skin and/or brittle nails?',
    type: 'PICKONE',
    options: [
      {
        text: 'Not at all',
        value: 'Not at all',
        score: 4,
      },
      {
        text: 'A bit',
        value: 'A bit',
        score: 3,
      },
      {
        text: 'Somewhat',
        value: 'Somewhat',
        score: 2,
      },
      {
        text: 'Quite a lot',
        value: 'Quite a lot',
        score: 1,
      },
      {
        text: 'Fully',
        value: 'Fully',
        score: 0,
      },
    ],
    nextTitle: `Continue`,
    cantBypass: true,
  },
  {
    id: 'Tired',
    title: 'In the past four weeks have you been tired?',
    type: 'PICKONE',
    options: [
      {
        text: 'Not at all',
        value: 'Not at all',
        score: 4,
      },
      {
        text: 'A bit',
        value: 'A bit',
        score: 3,
      },
      {
        text: 'Somewhat',
        value: 'Somewhat',
        score: 2,
      },
      {
        text: 'Quite a lot',
        value: 'Quite a lot',
        score: 1,
      },
      {
        text: 'Fully',
        value: 'Fully',
        score: 0,
      },
    ],
    nextTitle: `Continue`,
    cantBypass: true,
  },
  {
    id: 'DifficultiesMotivated',
    title: 'In the past four weeks did you have difficulties being motivated to do things?',
    type: 'PICKONE',
    options: [
      {
        text: 'Not at all',
        value: 'Not at all',
        score: 4,
      },
      {
        text: 'A bit',
        value: 'A bit',
        score: 3,
      },
      {
        text: 'Somewhat',
        value: 'Somewhat',
        score: 2,
      },
      {
        text: 'Quite a lot',
        value: 'Quite a lot',
        score: 1,
      },
      {
        text: 'Fully',
        value: 'Fully',
        score: 0,
      },
    ],
    nextTitle: `Continue`,
    cantBypass: true,
  },
  {
    id: 'Energetic',
    title: 'In the past four weeks did you feel energetic?',
    type: 'PICKONE',
    options: [
      {
        text: 'Not at all',
        value: 'Not at all',
        score: 4,
      },
      {
        text: 'A bit',
        value: 'A bit',
        score: 3,
      },
      {
        text: 'Somewhat',
        value: 'Somewhat',
        score: 2,
      },
      {
        text: 'Quite a lot',
        value: 'Quite a lot',
        score: 1,
      },
      {
        text: 'Fully',
        value: 'Fully',
        score: 0,
      },
    ],
    nextTitle: `Continue`,
    cantBypass: true,
  },
  {
    id: 'DifficultiesRemembering',
    title: 'In the past four weeks have you had difficulties remembering?',
    type: 'PICKONE',
    options: [
      {
        text: 'Not at all',
        value: 'Not at all',
        score: 4,
      },
      {
        text: 'A bit',
        value: 'A bit',
        score: 3,
      },
      {
        text: 'Somewhat',
        value: 'Somewhat',
        score: 2,
      },
      {
        text: 'Quite a lot',
        value: 'Quite a lot',
        score: 1,
      },
      {
        text: 'Fully',
        value: 'Fully',
        score: 0,
      },
    ],
    nextTitle: `Continue`,
    cantBypass: true,
  },
  {
    id: 'SlowThinking',
    title: 'In the past four weeks have you had slow or unclear thinking?',
    type: 'PICKONE',
    options: [
      {
        text: 'Not at all',
        value: 'Not at all',
        score: 4,
      },
      {
        text: 'A bit',
        value: 'A bit',
        score: 3,
      },
      {
        text: 'Somewhat',
        value: 'Somewhat',
        score: 2,
      },
      {
        text: 'Quite a lot',
        value: 'Quite a lot',
        score: 1,
      },
      {
        text: 'Fully',
        value: 'Fully',
        score: 0,
      },
    ],
    nextTitle: `Continue`,
    cantBypass: true,
  },
  {
    id: 'AfraidAnxious',
    title: 'In the past four weeks have you felt afraid or anxious?',
    type: 'PICKONE',
    options: [
      {
        text: 'Not at all',
        value: 'Not at all',
        score: 4,
      },
      {
        text: 'A bit',
        value: 'A bit',
        score: 3,
      },
      {
        text: 'Somewhat',
        value: 'Somewhat',
        score: 2,
      },
      {
        text: 'Quite a lot',
        value: 'Quite a lot',
        score: 1,
      },
      {
        text: 'Fully',
        value: 'Fully',
        score: 0,
      },
    ],
    nextTitle: `Continue`,
    cantBypass: true,
  },
  {
    id: 'DifficultiesManagingDailyLife',
    title: 'In the past four weeks, did you feel you had difficulties managing your daily life?',
    type: 'PICKONE',
    options: [
      {
        text: 'Not at all',
        value: 'Not at all',
        score: 4,
      },
      {
        text: 'A bit',
        value: 'A bit',
        score: 3,
      },
      {
        text: 'Somewhat',
        value: 'Somewhat',
        score: 2,
      },
      {
        text: 'Quite a lot',
        value: 'Quite a lot',
        score: 1,
      },
      {
        text: 'Fully',
        value: 'Fully',
        score: 0,
      },
    ],
    nextTitle: `Continue`,
    cantBypass: true,
  },
  {
    id: 'EverythingTakesLonger',
    title: 'In the past four weeks, did you feel everything takes longer to do?',
    type: 'PICKONE',
    options: [
      {
        text: 'Not at all',
        value: 'Not at all',
        score: 4,
      },
      {
        text: 'A bit',
        value: 'A bit',
        score: 3,
      },
      {
        text: 'Somewhat',
        value: 'Somewhat',
        score: 2,
      },
      {
        text: 'Quite a lot',
        value: 'Quite a lot',
        score: 1,
      },
      {
        text: 'Fully',
        value: 'Fully',
        score: 0,
      },
    ],
    nextTitle: `Continue`,
    cantBypass: true,
  },
  {
    id: 'ThyroidNegativeImpactQualityOfLife',
    title: 'In the past four weeks, has your thyroid had a negative impact on your quality of life?',
    type: 'PICKONE',
    options: [
      {
        text: 'Not at all',
        value: 'Not at all',
        score: 4,
      },
      {
        text: 'A bit',
        value: 'A bit',
        score: 3,
      },
      {
        text: 'Somewhat',
        value: 'Somewhat',
        score: 2,
      },
      {
        text: 'Quite a lot',
        value: 'Quite a lot',
        score: 1,
      },
      {
        text: 'Fully',
        value: 'Fully',
        score: 0,
      },
    ],
    nextTitle: `Continue`,
    cantBypass: true,
  },
  {
    id: 'IdentifyAs',
    title: 'Do you identify yourself as?',
    type: 'PICKONEOTHER',
    options: [
      {
        text: 'Black',
        value: 'Black',
      },
      {
        text: 'Asian',
        value: 'Asian',
      },
      {
        text: 'Hispanic',
        value: 'Hispanic',
      },
      {
        text: 'Native American',
        value: 'Native American',
      },
      {
        text: 'White',
        value: 'White',
      },
      {
        text: 'Prefer not to say',
        value: 'Prefer not to say',
      },
      {
        text: 'Other',
        value: 'Other',
        hasDetails: true,
      },
    ],
    nextTitle: `Continue`,
    cantBypass: true,
  },
];
